import { ConstructPost } from '../../types/ConstructPost';
import { NonPaginatedResponse } from '../../types/NonPaginatedResponse';
import { PLUGIN_BASE_PATH } from '../constants/pluginBasePath';

export const appendRelationship = (
  constructPost: ConstructPost,
  uuid: string,
  definition: string,
  children: string[],
  data: Record<string, any>,
): Promise<NonPaginatedResponse<any> | undefined> =>
  constructPost<NonPaginatedResponse<any>>(
    `${PLUGIN_BASE_PATH}/append-relationship/${uuid}`,
    { data: { definition, children, ...data } },
    { preventDefaultErrorToast: true },
  );
